document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".sound-hover-btn");
  const soundUrl = "https://cdn.shopify.com/s/files/1/0814/9975/0678/files/KoxnwwEQHSLNC4Eqn4RcMrWefYs.mp3?v=1763792684";
  const sound = new Audio(soundUrl);
  let audioUnlocked = false;
  let isPlaying = false;
  document.addEventListener("click", function () {
    if (!audioUnlocked) {
      sound.play().then(() => {
        sound.pause();
        sound.currentTime = 0;
        audioUnlocked = true;
      });
    }
  }, { once: true });
  buttons.forEach(btn => {
    btn.addEventListener("mouseenter", function () {
      if (!audioUnlocked) return;
      if (isPlaying) return;
      isPlaying = true;
      sound.currentTime = 0;
      sound.play().catch(() => {});
    });
    btn.addEventListener("mouseleave", function () {
      sound.pause();
      sound.currentTime = 0;
      isPlaying = false;
    });
  });
});


class ClickSpark extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = this.createSpark();
    this.svg = this.shadowRoot.querySelector("svg");
    this._parent = document.body;
    this._parent.addEventListener("click", this);
  }

  disconnectedCallback() {
    this._parent.removeEventListener("click", this);
  }

  handleEvent(e) {
    this.updateSparkColorBasedOnBackground(e);
    this.setSparkPosition(e);
    this.animateSpark();
  }

updateSparkColorBasedOnBackground(e) {
  let el = document.elementFromPoint(e.clientX, e.clientY);
  if (!el) return;

  let currentEl = el;
  let bg = null;
  let hasGradient = false;

  // Traverse up the DOM to find effective background
  while (currentEl && currentEl !== document.body) {
    const style = getComputedStyle(currentEl);
    const bgColor = style.backgroundColor;
    const bgImage = style.backgroundImage;

    // Check for specific gradient classes first
    if (currentEl.classList.contains('linear-gradiant--color--transparent') || 
        currentEl.classList.contains('linear-gradiant--color')) {
      hasGradient = true;
      break; // Treat these classes as gradients, set black spark
    }

    // Check for gradient in background-image
    if (bgImage !== 'none' && (bgImage.includes('linear-gradient') || bgImage.includes('radial-gradient'))) {
      hasGradient = true;
      break; // Stop here, we'll handle gradient specially
    }

    // Parse solid color if not transparent
    const match = bgColor.match(/\d+/g);
    if (match && match.length >= 3) {
      const nums = match.map(Number);
      // Skip fully transparent backgrounds (rgba(0,0,0,0) or similar)
      if (nums.length === 4 && nums[3] === 0) {
        // Continue to parent
      } else {
        const [r, g, b] = nums.slice(0, 3);
        bg = { r, g, b };
        break; // Found solid color, use it
      }
    }

    // Continue to parent if transparent or invalid
    currentEl = currentEl.parentElement;
  }

  // If specific classes or gradient detected, treat as light (black spark)
  if (hasGradient) {
    this.style.setProperty("--click-spark-color", "#000000");
    return;
  }

  // If still no bg (e.g., reached body, default to white)
  if (!bg) {
    this.style.setProperty("--click-spark-color", "#ffffff");
    return;
  }

  // brightness formula
  const brightness = (bg.r * 299 + bg.g * 587 + bg.b * 114) / 1000;

  // dark background → white spark
  if (brightness < 128) {
    this.style.setProperty("--click-spark-color", "#ffffff");
  } else {
    // light background → black spark
    this.style.setProperty("--click-spark-color", "#000000");
  }
}

  animateSpark() {
    let sparks = [...this.svg.children];
    let size = parseInt(sparks[0].getAttribute("y1"));
    let offset = size / 2 + "px";

    let keyframes = (i) => {
      let deg = `calc(${i} * (360deg / ${sparks.length}))`;
      return [
        {
          strokeDashoffset: size * 3,
          transform: `rotate(${deg}) translateY(${offset})`
        },
        {
          strokeDashoffset: size,
          transform: `rotate(${deg}) translateY(0)`
        }
      ];
    };

    let options = {
      duration: 660,
      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      fill: "forwards"
    };

    sparks.forEach((spark, i) => spark.animate(keyframes(i), options));
  }

  setSparkPosition(e) {
    this.style.left = e.pageX - 30 + "px";
    this.style.top = e.pageY - 30 + "px";
    this.style.position = "absolute";
    this.style.pointerEvents = "none";
    this.style.zIndex  = "3";
  }

  createSpark() {
    return `
      <style>
        :host {
          position: absolute;
          pointer-events: none;
        }
      </style>
      <svg width="60" height="60" viewBox="0 0 100 100" fill="none"
           stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
           stroke="var(--click-spark-color, currentcolor)" transform="rotate(-20)">
        ${Array.from(
          { length: 4 },
          () =>
            `<line x1="50" y1="30" x2="50" y2="4" 
              stroke-dasharray="30" stroke-dashoffset="30" style="transform-origin: center" />`
        ).join("")}
      </svg>
    `;
  }
}

customElements.define("click-spark", ClickSpark);

/*** COLOR PICKER OVERRIDE ***/
const spark = document.querySelector("click-spark");
document.getElementById("click-spark-color").addEventListener("change", (e) => {
  spark.style.setProperty("--click-spark-color", e.target.value);
});



document.addEventListener("scroll", function () {
  const images = document.querySelectorAll(
    ".homepage.main_collection_list .itg_image_scale, .itg_multi_image_text_main .itg_image_scale,.itg_landing_banner_main .itg_image_scale,.itg_image_and_text_main .itg_image_scale,.itg_image_text_sticky_bg .itg_image_scale"
  );
  if (!images.length) return;
  const windowHeight = window.innerHeight;
  images.forEach(image => {
    const section = image.closest(".main_collection_list, .itg_multi_image_text_main,.itg_landing_banner_main,.itg_image_and_text_main,.itg_image_text_sticky_bg");
    if (!section) return;
    const rect = section.getBoundingClientRect();
    const sectionHeight = rect.height;
    const inView = rect.bottom > 0 && rect.top < windowHeight;
    if (!inView) {
      image.dataset.scaled = "false";
      image.style.transform = "scale(1.2)";
      return;
    }
    if (image.dataset.scaled === "true") return;
    const scrollProgress = Math.min(
      Math.max((windowHeight - rect.top) / (sectionHeight + windowHeight), 0),
      1
    );
    const scale = 1.2 - (0.3 * scrollProgress);
    if (scale <= 1) {
      image.style.transform = "scale(1)";
      image.dataset.scaled = "true";
      return;
    }
    image.style.transform = `scale(${scale})`;
  });
});


document.querySelectorAll('.sound-hover-btn a').forEach((btn) => {
  btn.addEventListener('click', function (e) {
    const href = btn.getAttribute('href');

    // Only handle in-page anchors (with #)
    if (href && href.includes('#')) {
      e.preventDefault();

      const target = document.querySelector('.hbspt-form');

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  });
});